import React from 'react';
import { RadioProps } from './types';
import { RadioContainer, RadioInput, RadioLabel } from './styled';
import { useRadioGroupContext } from '../radio-group';

export const Radio: React.FC<RadioProps> = ({
  text,
  value,
  checked,
  onChange,
  disabled = false,
  ...rest
}) => {
  const groupName = useRadioGroupContext();
  const uniqueId = `${groupName || "radioGroup"}-${value}`;
  
  return (
    <RadioContainer>
      <RadioInput
        name={groupName || "radioGroup"}
        type="radio"
        id={uniqueId}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        {...rest}
      />
      <RadioLabel htmlFor={uniqueId}>
        {text}
      </RadioLabel>
    </RadioContainer>
  );
};

export default Radio;
